export default class LogIndex {

	constructor(name) {
		window[name] = this.data()
	}

	data() {
		return {
			loading: true,
			items: [],
			catId: null,
			interval: 2000,
			count: 0,

			query: '',

			init() {
				var vm = this;
				var xhttp = new XMLHttpRequest();

				xhttp.onreadystatechange = function() {
					if (this.readyState == 4 && this.status == 200) {

						vm.loading = false
						vm.items = JSON.parse(this.responseText);
					}
				}

				xhttp.open('get', '/api/log', true);
				var csrf = document.querySelector('meta[name="csrf-token"]').getAttribute('content')
				xhttp.setRequestHeader('X-CSRF-TOKEN', csrf);
				xhttp.setRequestHeader('Content-type', 'application/json;charset=utf-8');
				// setTimeout(function() {
					xhttp.send();
				// }, 500)
			},

			loop(vm = this){
				setInterval(function(){
					vm.count += ( 100 / 60 )
					if( vm.count >= 100){
						vm.init();
						vm.count = 0;
					}
				}, vm.interval )
			},

			EditItem(Item) {
				if(Item.type == "Task") return Turbolinks.visit( '/task/' + Item.id )
				if(Item.type == "TestReport") return Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.item_id + '/test-report/' + Item.id )
				if(Item.type == "Issue") return Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.item_id + '/issue/' + Item.id )
			},

			GetClass(Item){
				if( Item.type == 'Issue' ) return Item.label.class
				if( Item.type == 'TestReport' ) return Item.label.class
				if( Item.type == 'Task' ) return Item.label.class

				return 'default'
			},

			OpenIssue(Item){
				Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.item_id + '/issue/' +  Item.id)
			},

			CreateTestReport(Item){
				Turbolinks.visit( '/term/' + Item.term_id + '/item/' + Item.id + '/test-report/create')	
			},

			filterItems(vm = this) {

				var AllItems = vm.items;
				var SearchableKeys = ['name']
				var SearchString = vm.query.toLowerCase();

				return AllItems.filter(product => {
					let flag = false;
					for (let SearchKey of SearchableKeys) {
						if( product[SearchKey] ){
							flag = product[SearchKey].toString().toLowerCase().indexOf(SearchString) > -1
						}
						if (flag) break;
					}
					return flag;
				});
			}
		}
	}
}